<span *ngIf="title" class="title">{{ title }}</span>
<div class="d-flex align-items-center">
    <div class="progress m-progress--lg m--bg-metal progress-size progress-radius w-100">
        <div role="progressbar" class="progress-bar m--bg-brand progress-radius">&nbsp;</div>
    </div>
    <span class="progressText">{{ progressText$ | async }}</span>
</div>
